import type { ISpread } from "../../spreadsSlice";

export const psychologicalCircleSpread: ISpread = {
  id: "spread_psychological_circle",
  name: "Психологический круг",
  altNames: ["Psychological Circle Spread"],
  purpose:
    "Всестороннее исследование внутреннего состояния, диагностика баланса между различными сферами жизни и осознание взаимодействия разных уровней личности.",
  cardsCount: 9,
  layout: `    [2]
 [3]   [1]
[4] [9] [8]
 [5]   [7]
    [6]`,
  positions: [
    {
      id: "consciousness",
      title: "Сознание",
      meaning: "Мысли, цели и то, что осознаётся.",
    },
    {
      id: "unconscious",
      title: "Бессознательное",
      meaning: "Скрытые влияния и глубинные внутренние процессы.",
    },
    {
      id: "emotions",
      title: "Эмоции",
      meaning: "Чувства и эмоциональные реакции.",
    },
    {
      id: "physical_state",
      title: "Физическое состояние",
      meaning: "Состояние тела, здоровье и уровень энергии.",
    },
    {
      id: "social_environment",
      title: "Социальное окружение",
      meaning: "Люди, отношения и события внешней социальной среды.",
    },
    {
      id: "spirituality",
      title: "Духовное",
      meaning: "Связь с высшими смыслами и духовной стороной опыта.",
    },
    {
      id: "obstacles",
      title: "Текущие препятствия",
      meaning: "То, что ограничивает или затрудняет развитие.",
    },
    {
      id: "resources",
      title: "Ресурсы и помощь",
      meaning: "Поддержка, возможности и доступные внутренние или внешние ресурсы.",
    },
    {
      id: "core",
      title: "Центр / ядро личности",
      meaning: "Суть запроса и центральная тема внутреннего состояния.",
    },
  ],
  symbolism:
    "Круг символизирует целостность психики, а центр — ядро личности. Периферийные позиции показывают разные аспекты, через которые проявляется центральная тема.",
  archetypes: ["Круг", "Мандала", "Целостность", "Центр"],
  psychology:
    "Помогает увидеть взаимодействие разных сфер личности, определить корень внутреннего конфликта и обнаружить ресурсы для дальнейшей работы над собой.",
  procedure: {
    preparation:
      "Сформулировать вопрос о текущем внутреннем состоянии и о том, что важно понять.",
    steps:
      "Перетасовать колоду; выложить восемь карт по периферии круга, затем девятую карту в центр; сначала прочитать периферийные позиции и только после этого интерпретировать центр как квинтэссенцию расклада.",
  },
  interpretations: [
    "Противоречия между периферийными позициями могут показывать внутреннее напряжение.",
    "Позиция ресурсов помогает понять, на что можно опереться.",
    "Центральная карта связывает отдельные аспекты в общую картину.",
  ],
  nuances: [
    "Не начинать интерпретацию с центральной карты.",
    "Сначала следует понять отдельные сферы и их взаимодействие.",
    "Противоречия между картами являются значимой частью психологического анализа.",
  ],
  examples: [
    {
      cards: [
        "Маг",
        "Луна",
        "3 Мечей",
        "4 Жезлов",
        "Влюбленные",
        "Отшельник",
        "5 Пентаклей",
        "Императрица",
        "Колесница",
      ],
      interpretation:
        "Сознательное стремление к действию сочетается со скрытыми страхами и эмоциональной болью; при наличии внешней и внутренней поддержки центральной темой становится движение к цели.",
    },
  ],
  selfQuestions: [
    "Что составляет ядро моей личности сейчас?",
    "Как отдельные сферы влияют друг на друга?",
    "Где находится точка напряжения, а где — ресурс?",
  ],
};

